module.exports = __webpack_public_path__ + "static/implant-4c740eecbc4445e816abf7d2ac51f7e5.jpg";